import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Context = React.createContext<any>({});

export type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  staticProps: any;
  children?: React.ReactNode;
};

export function BlogContextProvider({ staticProps, children }: Props) {
  return <Context.Provider value={staticProps}>{children}</Context.Provider>;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useBlogPostContext() {
  return React.useContext(Context);
}
